/* jshint forin:true, noarg:true, noempty:true, eqeqeq:true, bitwise:true, strict:true, undef:true, unused:true, browser:true, devel:true, jquery:true, indent:4, maxerr:50, boss:true, trailing:true, white:true, sub:true*/
/* globals  jQuery:true, TweenMax:true, window:true, navigator:true, Draggable:true, el_preload:true, Power1:true, TimelineMax:true, Power4:true, Spinner:true, Sector:true, Back:true*/

(function ($) {
  'use strict';

  Drupal.behaviors.ModuleReNutriveAlchemy = {
    attach: function (context, settings) {
      // /////////////////////////////////
      // BEGIN: Utility Functions
      // /////////////////////////////////
      /*
       * @function getInternetExplorerVersion
       * @description Returns the version of Internet Explorer or a -1 (indicating the use of another browser).
       * @see: https://msdn.microsoft.com/en-us/library/ms537509(v=vs.85).aspx
       * @returns {Number} -1 if not any IE version, any other number otherwise
       */
      function getInternetExplorerVersion() {
        var rv = -1,
          ua,
          re,
          verStringArr;

        // works up to IE 10 but IE 11 spoofs this value. seperate check for IE Edge
        if (navigator.appName === 'Microsoft Internet Explorer') {
          ua = navigator.userAgent;
          re = new RegExp('MSIE ([0-9]{1,}[.0-9]{0,})');
          if (re.exec(ua) !== null) {
            rv = parseFloat(RegExp.$1);
          }
        } else if (
          navigator.appName === 'Netscape' &&
          navigator.userAgent.indexOf('Trident') > -1
        ) {
          rv = 11;
        } else if (navigator.appName === 'Netscape' && navigator.userAgent.indexOf('Edge') > -1) {
          ua = navigator.userAgent;
          re = new RegExp('Edge/([0-9]{1,}[.0-9]{0,})');
          verStringArr = re.exec(ua);
          if (verStringArr.length !== 0) {
            rv = Math.floor(parseFloat(verStringArr[0].split('/')[1]));
          }
        }

        return rv;
      }

      // /////////////////////////////////
      // END: Utility Functions
      // /////////////////////////////////

      // /////////////////////////////////
      // BEGIN: Boutique Implementation
      // /////////////////////////////////
      (function ($) {
        var MAIN = new Sector({
            loop: true,
            debug: false
          }),
          // DOM Elements
          $window = $(window),
          $body = $('body'),
          $siteContainer = $('#re-nutriv-alchemy_container'),
          $parallaxContainer = $siteContainer.find('.parallax'),
          // Boutique variables
          sectionClass = 're-nutriv-alchemy_section',
          sectionID = 're-nutriv-alchemy_section-',
          // Debug
          debug = window.location.search.indexOf('debug=true') !== -1 ? true : false,
          // Platform check vars
          mobileSize,
          isMobile,
          isDesktop,
          isIpad,
          ieVersion,
          // Video
          $videoPlayer = $('#video_player'),
          videoOptions = {
            url_html5media: '/includes/html5media/html5media.min.js',
            debug: false,
            controls: false,
            autoplay: false
          };

        // Preform platform checks here
        {
          mobileSize = 640;
          isMobile =
            typeof site !== 'undefined'
              ? site.client.isMobile
              : /iphone|ipod|android|blackberry|mini|windows\sce|palm/i.test(
                  navigator.userAgent.toLowerCase()
                );
          isDesktop = !isMobile;
          isIpad = navigator.userAgent.toLowerCase().match(/ipad/i) !== null;
          ieVersion = getInternetExplorerVersion();

          // set classes for desktop/mobile/ipad/ie
          if (isIpad) {
            $body.addClass('ipad');
          } else {
            $body.addClass(isMobile ? 'mobile' : 'desktop');
          }

          if (ieVersion !== -1) {
            $body.addClass('ie');
          }

          if (ieVersion === 9) {
            $body.addClass('ie-9');
          }

          isMobile = $(window).width() <= 640;
          if (isMobile) {
            $body.addClass('mobile');
          }
        }

        // Video Initial
        {
          $videoPlayer.html5mediaplayer('init');
        }

        var deeplinkMethods = {
          deeplinking: false,
          // Takes the window's hash and grabs the appropriately defined target and feeds it to the section
          deeplink: function () {
            if (debug) {
              console.log('deeplink fn', window.location.hash);
            }
            if (window.location.hash.length !== 0) {
              var targetSectionNum = window.location.hash.split('/')[1],
                $targetSection = $(sectionID + targetSectionNum);

              if (
                typeof $targetSection.data('section') !== 'undefined' &&
                $targetSection.length !== 0
              ) {
                deeplinkMethods.deeplinking = true;
                $targetSection.data('section').deeplink();
              }

              deeplinkMethods.deeplinking = false;

              return true;
            }

            return false;
          },
          getDeeplink: function () {
            if (window.location.hash.length !== 0) {
              var targetSectionNum = window.location.hash.split('/')[1],
                $targetSection = $('#' + sectionID + targetSectionNum);

              if ($targetSection.length !== 0) {
                return $targetSection;
              }
            }

            return $siteContainer.find('.' + sectionClass).first();
          },
          // Set the deeplink target if its new and don't disturb search history
          setDeeplink: (function () {
            var current = '#/';

            return function (hash) {
              if (hash === current) {
                return false;
              }
              current = hash;
              location.replace(hash);
            };
          })()
        };
        // Customize global sector JS functionality here
        var generateSection = function ($element, options) {
          var elementId = $element.attr('id');

          if (typeof $element === 'undefined' || $element.length === 0) {
            return;
          }

          options = $.extend({}, options);

          return {
            element: $element,
            load: function () {
              if (debug) {
                console.log(elementId + ': load');
              }

              if (typeof options.load === 'function') {
                options.load.apply(this, arguments);
              }
            },
            unload: function () {
              if (debug) {
                console.log(elementId + ': unload');
              }

              $element.removeClass('active');

              if (typeof options.unload === 'function') {
                options.unload.apply(this, arguments);
              }
            },
            update: function () {
              if (debug) {
                console.log(elementId + ': update');
              }

              if (arguments[0] >= 0.4) {
                $element.addClass('active');
              } else {
                $element.removeClass('active');
              }

              // Do not allow updates if deeplinking
              if (deeplinkMethods.deeplinking) {
                return;
              }

              if (typeof options.update === 'function') {
                options.update.apply(this, arguments);
              }
            },
            deeplink: function () {
              if (debug) {
                console.log(elementId + ': deeplink');
              }

              if (!$element.is(':first-child') || $element.is('#re-nutriv-alchemy_section-6')) {
                TweenMax.to($window, 1, {
                  scrollTo: $element.offset().top,
                  onComplete: function () {
                    deeplinkMethods.deeplinking = false;
                    MAIN.update(true);
                  }
                });
              } else {
                deeplinkMethods.deeplinking = false;
                MAIN.update(true);
              }

              // Ensure the deeplinking is 'off' after a set time
              window.setTimeout(function () {
                deeplinkMethods.deeplinking = false;
                MAIN.update(true);
              }, 2000);

              if (typeof options.deeplink === 'function') {
                options.deeplink.apply(this, arguments);
              }
            }
          };
        };
        // Handles post preload functionality when called
        var postLoad = function () {
          if (debug) {
            console.log('postLoad fired');
          }

          /*
           * ELPRODUCT
           */
          // prune trailing comma from prod ID list
          $('.el-product_id-list').text($('.el-product_id-list').text().slice(0, -1));

          // Run EL Product plugin
          $('#re-nutriv-alchemy_section-1, #re-nutriv-alchemy_section-7').elproduct({
            target: '.el-product',
            template: '.hidden-products-markup-to-clone .el-product',
            products: '.el-product_id-list',
            debug: false
          });

          // Resize handler that should trigger resize handling with a delay after a resize
          var resizeHandler = _.debounce(function () {
            // Add mobile class if desktop class scales under mobile size
            if ($body.hasClass('desktop')) {
              if ($window.width() <= mobileSize && !$body.hasClass('mobile')) {
                $body.addClass('mobile');
                isMobile = true;
                $(window).trigger('desktopGainedMobile');
              } else if ($window.width() > mobileSize && $body.hasClass('mobile')) {
                $body.removeClass('mobile');
                isMobile = false;
                $(window).trigger('desktopLostMobile');
              }
            }
          }, 500);

          /*
					Scroll handling, also covers touchmove and touchend for smoother iOS updates
				*/
          $window.on('scroll touchmove touchend', function () {
            var $activeSections,
              scrollTop = $window.scrollTop();

            /*
						 Required for section load, unload, and update functions called by this function
						 There may be additional animations and functionality implemented in those functions that need to be called.
					*/
            MAIN.update(true);

            // Slides in 4-6 should not set deeplinks
            $activeSections = $siteContainer
              .find('.' + sectionClass + '.active, .re-nutriv-alchemy_section-container.active')
              .not($siteContainer.find('#container_4-6').find('.slide'));

            // Update deeplink if not currently deeplinking, if there are sections, and window isn't at maximum scroll
            if (
              !deeplinkMethods.deeplinking &&
              $activeSections.length !== 0 &&
              scrollTop !== $('body').height() - $(window).height()
            ) {
              deeplinkMethods.setDeeplink(
                '#/' +
                  $activeSections
                    .first()
                    .attr('id')
                    .replace(sectionID, '')
                    .replace('container_', '')
              );
            }
            // Updated deeplink to last section if window is at maximum scroll
            // Implemented due to previous section catching deeplink conditions, while the last section almost never does
            else if (
              $activeSections.length !== 0 &&
              scrollTop === $('body').height() - $(window).height()
            ) {
              deeplinkMethods.setDeeplink(
                '#/' +
                  $activeSections.last().attr('id').replace(sectionID, '').replace('container_', '')
              );
            }
          });

          // on resize update MAIN and update desktop/mobile classes
          $window.resize(resizeHandler).trigger('resize');

          // singular product quickshop/add to bag
          $('.el-product_shop-now').on('click', function (e) {
            var $this = $(this);

            // if shop button is tied to add-to-bag run addToCart, else if quickshop do quickshop, else go to SPP
            if ($this.hasClass('add-to-bag')) {
              e.preventDefault();

              // add the item to the cart
              site.addToCart({
                skuData: {
                  SKU_BASE_ID: $this.attr('data-sku').substr(3),
                  PARENT_CAT_ID: $this.attr('data-product')
                },
                quantity: 1,
                QTY: 1
              });
            } else if ($this.hasClass('quickshop')) {
              e.preventDefault();
              site.quickshop($this.data('full_product_json'));
            }
          });

          // Trigger postLoad event
          $window.trigger('postLoad');
        };

        /*
				Fires on postLoad to ensure _all_ content is loaded per slide before setting up section functionality
				Previous functionality would have section functionality created before images were loaded, causing animation issues due to un-inflated
				sizes.
			*/
        $(window).on('postLoad', function () {
          // /////////////////////////////
          // BEGIN: Global
          // /////////////////////////////
          (function () {
            {
              var $modalVideo = $siteContainer.find('.video_container'),
                $modalQuickshop = $siteContainer.find('.modal_container');

              $(window).on('keydown', function (e) {
                // e.preventDefault();
                if (e.which === 27) {
                  $modalVideo
                    .add($modalQuickshop)
                    .filter('.active')
                    .find('.close_btn')
                    .trigger('click');
                }
              });
            }
          })();
          // /////////////////////////////
          // END: Global
          // /////////////////////////////

          // /////////////////////////////
          // BEGIN: Section 1
          // /////////////////////////////
          (function () {
            var $self = $('#re-nutriv-alchemy_section-1'),
              $backgroundImage = $self.find('.hero_background'),
              $heroDewDrop = $self.find('.hero_dew-drop'),
              $heroGlow = $self.find('.hero_dew-glow'),
              $heroProduct = $self.find('.hero_product'),
              $discoverTheSecret = $self.find('.re-nutriv-alchemy_discover'),
              $arrow = $discoverTheSecret.find('img'),
              $landingText = $self.find('.re-nutriv-alchemy_text > *'),
              // Animation,
              introStarted = false,
              introTimeline = new TimelineMax({ paused: true });

            {
              // Discover the secrets button scrolls to Section 2
              $discoverTheSecret.on('click', function (e) {
                if (debug) {
                  console.log('Secrets clicked.');
                }

                e.preventDefault();
                TweenMax.to(window, 1, {
                  scrollTo: { y: $('#re-nutriv-alchemy_section-2').offset().top },
                  ease: Power4.easeOut
                });
              });
            }

            {
              if (isMobile) {
                introTimeline
                  .staggerFrom(
                    $landingText,
                    1,
                    {
                      opacity: 0,
                      delay: 0.5
                    },
                    0.1
                  )
                  .from($discoverTheSecret, 0.65, { opacity: 0 }, '-=.5');
              } else {
                introTimeline
                  .from($backgroundImage, 0.5, { opacity: 0 })
                  .from(
                    $heroDewDrop,
                    1.4,
                    {
                      opacity: 0,
                      top: '-=40%',
                      ease: Power4.easeOut
                    },
                    '-=.2'
                  )
                  .from($heroProduct, 0.85, { opacity: 0 }, '-=1.2')
                  .from($heroGlow, 0.6, { opacity: 0 }, '-=1')
                  .staggerFrom($landingText, 1, { opacity: 0 }, 0.1)
                  .from($discoverTheSecret, 0.65, { opacity: 0 }, '-=.5');
              }

              TweenMax.to($arrow, 2, {
                y: '+=40%',
                yoyo: true,
                repeat: -1,
                ease: Power4.easeInOut
              });
            }

            MAIN.add(
              generateSection($self, {
                load: function () {
                  if (!introStarted) {
                    introStarted = true;
                    introTimeline.play();
                  }
                }
              })
            );
          })();
          // /////////////////////////////
          // END: Section 1
          // /////////////////////////////

          // /////////////////////////////
          // BEGIN: Section 2
          // /////////////////////////////
          (function () {
            var $self = $('#re-nutriv-alchemy_section-2'),
              $tiles = $self.find('.tile'),
              $tileVideo = $self.find('.re-nutriv-alchemy_tiles').children(), // $self.find('.re-nutriv-alchemy_tiles .video'),
              // watch the film
              $watchTheFilm = $('.re-nutriv-alchemy_watch-film a'),
              // Animation
              introStarted = false,
              introTimeline = new TimelineMax({ paused: true }),
              // Video
              $modalVideo = $siteContainer.find('.video_container'),
              $modalVideoWrapper = $modalVideo.find('.video_wrapper'),
              $scrubber = $modalVideo.find('.scrubber-container'),
              $innerScrubber = $modalVideo.find('.inner_scrubber'),
              $modalVideoArrows = $modalVideo.find('.arrow'),
              outroInProgress = false,
              // Quickshop Modal
              $modalQuickshop = $siteContainer.find('.modal_container'),
              // Carousel
              $carousel = $self.find('.carousel'),
              $arrowLeft = $self.find('.carousel_pagers .arrow.left'),
              $arrowRight = $self.find('.carousel_pagers .arrow.right'),
              $pagination = $self.find('.carousel_pagination .dot');

            // Create carousel
            $carousel.el_carousel({
              useGSAP: true,
              increment: isMobile ? '74%' : '28.2%',
              offset: isMobile ? '10%' : '0%',
              duration: 0.5
            });

            {
              // REMOVE WHEN CSS IS UDPATED
              TweenMax.set($innerScrubber, { width: '100%' });
            }

            {
              introTimeline.from($carousel, 2, {
                x: '+=25%',
                opacity: 0
              });

              // Build tile hover animation
              $tiles.each(function () {
                var $this = $(this),
                  hoverTimeline = new TimelineMax({ paused: true });

                hoverTimeline.to($this, 0.6, {
                  opacity: 0.6,
                  ease: Power2.easeOut
                });

                $this.data('hoverTimeline', hoverTimeline);
              });
            }

            {
              // Opens video modal and respective video on click
              $tileVideo.add($watchTheFilm).on('click', function (e, dir) {
                var $this = $(this);
                var $video = $this.find('.video').addBack('.video');
                var videoURL = isMobile
                  ? $video.data('mobile-video-url')
                  : $video.data('video-url');
                var isTileVideo = $self.find('.re-nutriv-alchemy_tiles').has($this).length === 1;
                var introTimeline = new TimelineMax({
                  paused: true,
                  onComplete: function () {
                    // User has to initiate play via manual controls
                    if (!isMobile) {
                      $videoPlayer.html5mediaplayer('play');
                    }
                  }
                });
                var endCapImageDesktop;
                var endCapImageMobile;
                var $videoEndCaps = $modalVideo.find('.video-end-cap');
                var $videoEndCapDesktop = $modalVideo.find('.video-end-cap.desktop');
                var $videoEndCapMobile = $modalVideo.find('.video-end-cap.mobile');

                e.preventDefault();

                // TweenMax.fromTo($popUp, 0.5, {className: '-=active', opacity: 0}, {className: '+=active', opacity: 1});
                if (typeof videoURL !== 'undefined') {
                  if (isTileVideo) {
                    $this.addClass('active').siblings().removeClass('active');
                  } else {
                    $modalVideo.addClass('watch-the-film');
                  }

                  TweenMax.killTweensOf([$modalVideo.find('.tile_text_container'), $videoPlayer]);

                  // Build intro timeline

                  // Forwards
                  if (dir === 1) {
                    introTimeline.staggerFromTo(
                      [$modalVideo.find('.tile_text_container'), $videoPlayer.add($videoEndCaps)],
                      0.2,
                      {
                        opacity: 0,
                        x: '-5%'
                      },
                      {
                        opacity: 1,
                        x: '0%',
                        clearProps: 'y'
                      },
                      0.1
                    );
                  }
                  // Backwards
                  else if (dir === -1) {
                    introTimeline.staggerFromTo(
                      [$modalVideo.find('.tile_text_container'), $videoPlayer.add($videoEndCaps)],
                      0.2,
                      {
                        opacity: 0,
                        x: '5%'
                      },
                      {
                        opacity: 1,
                        x: '0%',
                        clearProps: 'y'
                      },
                      0.1
                    );
                  }
                  // Everything else
                  else {
                    introTimeline.staggerFromTo(
                      [$modalVideo.find('.tile_text_container'), $videoPlayer.add($videoEndCaps)],
                      0.2,
                      {
                        opacity: 0,
                        y: '5%'
                      },
                      {
                        opacity: 1,
                        y: '0%',
                        clearProps: 'y'
                      },
                      0.1
                    );
                  }

                  $videoPlayer.html5mediaplayer(
                    'player',
                    'http://' + location.host + videoURL,
                    videoOptions
                  );
                  $modalVideoWrapper.find('.play_btn').removeClass('active');

                  // Get placeholder images
                  endCapImageDesktop = $this.find('a').addBack('a').data('video-src');
                  endCapImageMobile = $this.find('a').addBack('a').data('mobile-video-src');

                  // Empty images use clear.gif instead
                  endCapImageDesktop =
                    typeof endCapImageDesktop === 'undefined' || endCapImageDesktop.length !== 0
                      ? endCapImageDesktop
                      : $('#image_path').attr('src');
                  endCapImageMobile =
                    typeof endCapImageMobile === 'undefined' || endCapImageMobile.length !== 0
                      ? endCapImageMobile
                      : $('#image_path').attr('src');

                  if (isTileVideo) {
                    $modalVideo.find('video').removeAttr('controls', 'controls');

                    $videoEndCapDesktop.attr('src', endCapImageDesktop);
                    $videoEndCapMobile.attr('src', endCapImageMobile);

                    // Display the placeholder immediately
                    TweenMax.set($videoEndCaps, { opacity: 1 });
                    $videoEndCaps.css({ display: '' });
                  } else if (!isTileVideo) {
                    if (isMobile) {
                      $modalVideo.find('video').attr('controls', 'controls');
                    }
                    $videoEndCaps.attr('src', $('#image_path').attr('src'));

                    // Hide the placeholder
                    TweenMax.set($videoEndCaps, { display: 'none' });
                  }

                  $modalVideoWrapper
                    .find('.tile_text_container')
                    .children()
                    .eq($tileVideo.index($this))
                    .addClass('active')
                    .siblings()
                    .removeClass('active');

                  // Set scrubber position to 0
                  TweenMax.set($innerScrubber, {
                    scaleX: 0,
                    transformOrigin: '0% 50%'
                  });

                  introTimeline.play();

                  // Set up video events
                  $videoPlayer
                    .find('video')
                    .off('ended pause play playing timeupdate')
                    .on('ended', function () {
                      var video = $videoPlayer.find('video')[0];
                      var exitFullscreen =
                        video.webkitExitFullscreen ||
                        video.mozCancelFullscreen ||
                        video.exitFullscreen;

                      // Video must have loaded frames for close to trigger
                      if (video.readyState > 1 && isMobile) {
                        if (typeof exitFullscreen !== 'undefined') {
                          exitFullscreen.call(video);
                        }
                      }
                    })
                    .on('pause', function () {
                      $modalVideoWrapper.find('.play_btn').removeClass('active');
                    })
                    .on('play playing', function () {
                      $modalVideoWrapper.find('.play_btn').addClass('active');
                    })
                    .on('timeupdate', function () {
                      var current;
                      var duration;
                      var scale;
                      var scaleEndCap;
                      var threshold = 0.2;

                      current = this.currentTime;
                      duration = this.duration;

                      scale = current / duration;
                      scaleEndCap = (scale - (1 - threshold)) / threshold;
                      scaleEndCap = scaleEndCap < 0 ? 0 : scaleEndCap > 1 ? 1 : scaleEndCap;

                      // TweenMax.set($innerScrubber, {scaleX: scale,force3D: true});
                      // (scale-(1-threshold))/threshold - scale by threshold
                      $innerScrubber.css('transform', 'scaleX(' + scale + ')');
                      if (!TweenMax.isTweening($videoEndCaps)) {
                        TweenMax.set($videoEndCaps, { opacity: scaleEndCap });
                      }
                    });

                  if (!$modalVideo.hasClass('active')) {
                    TweenMax.to($modalVideo, 1, {
                      display: 'block',
                      opacity: 1
                    });
                  }

                  $modalVideo.addClass('active');
                }
              });

              // Mobile functionality (re)starts video on click
              $modalVideo.find('.video-end-cap').on('click', function (e) {
                var $this = $(this);
                var $video;

                e.preventDefault();

                $video = $modalVideo.find('video');

                if ($video.length === 0) {
                  return;
                }

                if ($video[0].ended) {
                  $video[0].currentTime = 0;
                  $videoPlayer.html5mediaplayer('play');
                } else {
                  if ($video[0].paused) {
                    $videoPlayer.html5mediaplayer('play');
                  } else {
                    $videoPlayer.html5mediaplayer('pause');
                  }
                }

                TweenMax.to($this, 0.5, { opacity: 0 });
              });

              // Hover effects for tiles
              $tiles
                .on('mouseenter', function () {
                  var $this = $(this),
                    hoverTimeline = $this.data('hoverTimeline');

                  if (typeof hoverTimeline !== 'undefined') {
                    hoverTimeline.play(0);
                  }
                })
                .on('mouseleave', function () {
                  var $this = $(this),
                    hoverTimeline = $this.data('hoverTimeline');

                  if (typeof hoverTimeline !== 'undefined') {
                    hoverTimeline.reverse();
                  }
                });

              // Progresses videos in the video modal
              $modalVideoArrows.on('click', function (e) {
                var $this = $(this);
                var $currentTile = $tileVideo.filter('.active');
                var $next;
                var dir = 0;

                e.preventDefault();

                // Do not allow progress for watch-the-film
                if (outroInProgress || $modalVideo.hasClass('watch-the-film')) {
                  return;
                }

                outroInProgress = true;

                if ($this.hasClass('right')) {
                  $next = $currentTile.next();
                  if ($next.length === 0) {
                    $next = $tileVideo.first();
                  }

                  dir = 1;
                } else if ($this.hasClass('left')) {
                  $next = $currentTile.prev();

                  if ($next.length === 0) {
                    $next = $tileVideo.last();
                  }

                  dir = -1;
                }

                TweenMax.set($modalVideo.find('.video-end-cap'), { opacity: 1 });

                TweenMax.killTweensOf([$modalVideo.find('.tile_text_container'), $videoPlayer]);

                // Build intro timeline
                introTimeline
                  .to($modalVideo.find('.tile_text_container'), 0.2, { opacity: 0 })
                  .to($videoPlayer, 0.2, { opacity: 0 }, '0.1')
                  .eventCallback('onComplete', function () {
                    if ($videoPlayer.find('video').length !== 0) {
                      $videoPlayer.html5mediaplayer('pause');
                      // $videoPlayer.html5mediaplayer('destroy');
                      $videoPlayer.empty();
                      $videoPlayer.removeData('player');
                    }

                    $next.trigger('click', [dir]);
                    outroInProgress = false;
                  });

                introTimeline.play();
              });

              // Key progression: see click event binding for $modalVideoArrows('click')
              $window.on('keydown', function (e) {
                var key = e.which;

                if (!$modalVideo.hasClass('active')) {
                  return;
                }

                switch (key) {
                  // Left arrow
                  case 37:
                    $modalVideoArrows.filter('.left').trigger('click', [1]);
                    break;

                  // Right arrow
                  case 39:
                    $modalVideoArrows.filter('.right').trigger('click', [-1]);
                    break;
                }
              });

              // Swipe progression: see click event binding for $modalVideoArrows('click')
              $modalVideo.swipe({
                swipeLeft: function () {
                  if (!$modalVideo.hasClass('active')) {
                    return;
                  }

                  $modalVideoArrows.filter('.left').trigger('click', [1]);
                },
                swipeRight: function () {
                  if (!$modalVideo.hasClass('active')) {
                    return;
                  }

                  $modalVideoArrows.filter('.right').trigger('click', [-1]);
                }
              });

              // Video handlers
              // Closes and destroys the current video player
              $modalVideo.find('.close_btn').on('click', function (e) {
                e.preventDefault();
                // Assumes already closed
                if ($videoPlayer.find('video').length === 0) {
                  return;
                }

                $videoPlayer.html5mediaplayer('pause');

                TweenMax.to($modalVideo, 1, {
                  display: 'none',
                  opacity: 0,
                  onComplete: function () {
                    $videoPlayer.empty();
                    $videoPlayer.removeData('player');
                  }
                });

                $modalVideo.removeClass('active').removeClass('watch-the-film');
              });

              // Toggles video play state
              $modalVideoWrapper.find('.play_btn').on('click', function (e) {
                var video = $videoPlayer.find('video');
                var videoPaused;

                if (video.length === 0) {
                  return;
                }

                videoPaused = video[0].paused;

                e.preventDefault();

                if (videoPaused) {
                  $videoPlayer.html5mediaplayer('play');
                } else {
                  $videoPlayer.html5mediaplayer('pause');
                } // Toggle?
              });

              // Update video time based on scrubber click position
              $scrubber.on('click', function (e) {
                var $this = $(this);
                var offset = $this.offset().left;
                var width = $this.width();
                var clickPosition = e.clientX - offset;
                var scale = clickPosition / width;
                var $video = $videoPlayer.find('video');

                e.preventDefault();

                if ($video.length === 0) {
                  return;
                }

                TweenMax.set($innerScrubber, {
                  scaleX: scale,
                  transformOrigin: '0% 50%'
                });
                $video[0].currentTime = $video[0].duration * scale;
              });

              // Makes video fullscreen
              $modalVideoWrapper.find('.full_btn').on('click', function () {
                var $video = $videoPlayer.find('video');
                var video;
                var requestFullScreen;

                if ($video.length === 0) {
                  return;
                }

                video = $video[0];

                requestFullScreen =
                  video.requestFullscreen ||
                  video.msRequestFullscreen ||
                  video.mozRequestFullScreen ||
                  video.webkitRequestFullscreen;

                if (typeof requestFullScreen !== 'undefined' && requestFullScreen) {
                  requestFullScreen.call(video);
                }
              });

              // Rebuild carousel for mobile/desktop states
              $(window).on('desktopGainedMobile desktopLostMobile', function () {
                // Close video whenever mobile/desktop is triggered (as mobile/desktop have their own video clip versions);
                // Recreate carousel
                $carousel.carouselDestroy();
                $carousel.el_carousel({
                  useGSAP: true,
                  increment: isMobile ? '74%' : '28.2%',
                  offset: isMobile ? '10%' : '0%',
                  duration: 0.5
                });
              });

              // Quickshop modal handlers
              $modalQuickshop.find('.close_btn').on('click', function (e) {
                e.preventDefault();

                TweenMax.to($modalQuickshop, 1, {
                  display: 'none',
                  opacity: 0
                });
                $modalQuickshop.removeClass('active');
              });

              // Carousel handlers
              // Setup carousel keydown
              $window.on('keydown', function (e) {
                if (!$self.hasClass('active')) {
                  return;
                }

                if (e.which === 39) {
                  if (debug) {
                    console.log('Right, son');
                  }
                  $carousel.carouselNext();
                } else if (e.which === 37) {
                  if (debug) {
                    console.log('Left, mang');
                  }
                  $carousel.carouselPrev();
                }
              });

              // Swipe to progress Carousel
              if (typeof jQuery.fn.swipe !== 'undefined') {
                $self.swipe({
                  swipeLeft: function () {
                    $carousel.carouselNext();
                  },
                  swipeRight: function () {
                    $carousel.carouselPrev();
                  },
                  allowPageScroll: 'vertical',
                  preventDefaultEvents: false,
                  excludedElements: 'button, input, select, textarea, .noSwipe'
                });
              }

              // Arrow Left
              $arrowLeft.on('click', function (e) {
                e.preventDefault();
                $carousel.carouselPrev();
              });

              // Arrow Left
              $arrowRight.on('click', function (e) {
                e.preventDefault();
                $carousel.carouselNext();
              });

              // Updates the pagination dots when carousel updates
              $carousel.on('carousel_updated', function (e, index) {
                $pagination.eq(index).addClass('active').siblings().removeClass('active');
              });
            }

            MAIN.add(
              generateSection($self, {
                update: function () {
                  if (
                    !introStarted &&
                    $self.offset().top + $self.height() * 0.4 <
                      $(window).scrollTop() + $(window).height()
                  ) {
                    introStarted = true;
                    introTimeline.play();
                  }
                }
              })
            );
          })();
          // /////////////////////////////
          // END: Section 2
          // /////////////////////////////

          // /////////////////////////////
          // BEGIN: Section 3
          // /////////////////////////////
          (function () {
            var $self = $('#re-nutriv-alchemy_section-3'),
              // DOM
              $textParts = $self.find('.re-nutriv-alchemy_text > *'),
              $parallax = $self.find('.parallax-container .desktop'),
              // Animation
              introStarted = false,
              introTimeline = new TimelineMax({ paused: true }),
              parallaxAnimation;

            {
              introTimeline.staggerFrom($textParts, 1, { opacity: 0 }, 0.1);

              parallaxAnimation = TweenMax.to($parallax, 1, {
                y: '-=30%',
                paused: true
              });
            }

            {
              /* Parallax animation handled here as it needs to function regardless of if the section is 'active' via Sector.js */
              $window.on('scroll touchmove touchend', function () {
                var progress =
                  ($window.scrollTop() - $self.offset().top + $(window).height()) /
                  ($self.offset().top + $self.height());

                progress = progress < 0 ? 0 : progress > 1 ? 1 : progress;
                parallaxAnimation.progress(progress);
              });
            }

            MAIN.add(
              generateSection($self, {
                update: function () {
                  if (
                    !introStarted &&
                    $self.offset().top + $self.height() < $(window).scrollTop() + $(window).height()
                  ) {
                    introStarted = true;
                    introTimeline.play();
                  }
                }
              })
            );
          })();
          // /////////////////////////////
          // END: Section 3
          // /////////////////////////////

          // /////////////////////////////
          // BEGIN: Section 4 - 6 Carousel
          // /////////////////////////////
          if (!isMobile) {
            (function () {
              var $self = $('#container_4-6'),
                $carousel = $self.find('.carousel'),
                $arrows = $self.find('.carousel_pagers'),
                $arrowLeft = $self.find('.carousel_pagers .arrow.left'),
                $arrowRight = $self.find('.carousel_pagers .arrow.right'),
                $paginationContainer = $self.find('.carousel_pagination'),
                $pagination = $self.find('.carousel_pagination .dot'),
                interval = false,
                intervalRate = 8000,
                intervalResumeTimeout = false,
                introAnimation = new TimelineMax({
                  paused: true,
                  onComplete: function () {
                    startAutoplay();
                  }
                }),
                introStarted = false;

              /**
               * @function startAutoplay
               * @description Starts and or resumes carousel autoplay
               * @returns {undefined} - This function doesn't return anything
               */
              function startAutoplay() {
                if (interval) {
                  return;
                }

                interval = setInterval(function () {
                  $carousel.carouselNext();
                }, intervalRate);
              }

              // Create carousel
              $carousel.el_carousel({
                useGSAP: true,
                increment: '100%',
                duration: 0.5,
                dot_container: $self.find('.carousel_pagination')
              });

              {
                introAnimation
                  .from($carousel.children().first(), 1.5, {
                    x: '+=20%',
                    opacity: 0,
                    onComplete: function () {
                      $carousel.children('.node').first().trigger('slideHasGainedActive');
                    }
                  })
                  .from($arrows.add($paginationContainer), 1, { opacity: 0 });
              }

              {
                // Setup carousel keydown
                $window.on('keydown', function (e) {
                  if (!$self.hasClass('active')) {
                    return;
                  }

                  if (e.which === 39) {
                    $carousel.carouselNext();
                  } else if (e.which === 37) {
                    $carousel.carouselPrev();
                  }

                  if (e.which === 39 || e.which === 73) {
                    // Stop autoplay and resume after time specified in intervalRate
                    window.clearInterval(interval);
                    interval = false;
                    window.clearTimeout(intervalResumeTimeout);
                    intervalResumeTimeout = window.setTimeout(function () {
                      startAutoplay();
                    }, intervalRate);
                  }
                });

                // Swipe to progress Carousel
                if (typeof jQuery.fn.swipe !== 'undefined') {
                  $self.swipe({
                    swipeLeft: function () {
                      $carousel.carouselNext();

                      // Stop autoplay and resume after time specified in intervalRate
                      window.clearInterval(interval);
                      interval = false;
                      window.clearTimeout(intervalResumeTimeout);
                      intervalResumeTimeout = window.setTimeout(function () {
                        startAutoplay();
                      }, intervalRate);
                    },
                    swipeRight: function () {
                      $carousel.carouselPrev();

                      // Stop autoplay and resume after time specified in intervalRate
                      window.clearInterval(interval);
                      interval = false;
                      window.clearTimeout(intervalResumeTimeout);
                      intervalResumeTimeout = window.setTimeout(function () {
                        startAutoplay();
                      }, intervalRate);
                    },
                    allowPageScroll: 'vertical',
                    preventDefaultEvents: false,
                    excludedElements: 'button, input, select, textarea, .noSwipe'
                  });
                }

                // Arrow Left
                $arrowLeft.on('click', function (e) {
                  e.preventDefault();
                  $carousel.carouselPrev();

                  // Stop autoplay and resume after time specified in intervalRate
                  window.clearInterval(interval);
                  interval = false;
                  window.clearTimeout(intervalResumeTimeout);
                  intervalResumeTimeout = window.setTimeout(function () {
                    startAutoplay();
                  }, intervalRate);
                });

                // Arrow Left
                $arrowRight.on('click', function (e) {
                  e.preventDefault();
                  $carousel.carouselNext();

                  // Stop autoplay and resume after time specified in intervalRate
                  window.clearInterval(interval);
                  interval = false;
                  window.clearTimeout(intervalResumeTimeout);
                  intervalResumeTimeout = window.setTimeout(function () {
                    startAutoplay();
                  }, intervalRate);
                });

                // Dot Nav/ Pagination
                $pagination.on('click', function (e) {
                  var $this = $(this),
                    index = $this.index();

                  e.preventDefault();

                  $this.addClass('active').siblings().removeClass('active');
                  $carousel.carouselTo(index);

                  // Stop autoplay and resume after time specified in intervalRate
                  window.clearInterval(interval);
                  interval = false;
                  window.clearTimeout(intervalResumeTimeout);
                  intervalResumeTimeout = window.setTimeout(function () {
                    startAutoplay();
                  }, intervalRate);
                });

                // Updates the pagination dots when carousel updates
                $carousel.on('carousel_updated', function (e, index) {
                  $pagination.eq(index).addClass('active').siblings().removeClass('active');
                });

                $(window).on('desktopGainedMobile', function () {
                  // Clear carousel related setup
                  $carousel.carouselDestroy();
                  $carousel.children().attr('style', '');
                  introAnimation.kill();
                });

                $(window).on('desktopLostMobile', function () {
                  // Create carousel
                  $carousel.carouselDestroy();
                  $carousel.el_carousel({
                    useGSAP: true,
                    increment: '100%',
                    duration: 0.5,
                    dot_container: $self.find('.carousel_pagination')
                  });

                  startAutoplay();
                });

                // Stops autoplay if event is called
                $self
                  .on('stop_autoplay', function () {
                    window.clearInterval(interval);
                    interval = false;
                    window.clearTimeout(intervalResumeTimeout);
                  })
                  .on('start_autoplay', function () {
                    startAutoplay();
                  });
              }

              MAIN.add(
                generateSection($self, {
                  update: function () {
                    if (
                      !isMobile &&
                      !introStarted &&
                      $self.offset().top + $self.height() * 0.6 <=
                        $(window).scrollTop() + $(window).height()
                    ) {
                      introStarted = true;
                      introAnimation.play();
                    }
                  }
                })
              );
            })();
          }
          // /////////////////////////////
          // END: Section 4 - 6 Carousel
          // /////////////////////////////

          // /////////////////////////////
          // BEGIN: Section 4
          // /////////////////////////////
          (function () {
            var $self = $('#re-nutriv-alchemy_section-4'),
              $parent = $('#container_4-6'),
              // DOM
              $environments = $self.find('.re-nutriv-alchemy_environments'),
              $envBrasil = $environments.find('.brasil'),
              $envHimalaya = $environments.find('.himalayans'),
              $brasilHover = $self.find('.brasil-hover'),
              $himalayaHover = $self.find('.himalayans-hover'),
              $brasilText = $envBrasil.find('h2'),
              $himalayaText = $envHimalaya.find('h2'),
              $closeBtn = $environments.find('.close'),
              // Animation
              hoverBra = new TimelineMax({ paused: true }),
              hoverHim = new TimelineMax({ paused: true }),
              showBra = new TimelineMax({ paused: true }),
              showHim = new TimelineMax({ paused: true });

            {
              // introTimeline
              // .from($environments.find('> *'), 0.65, {opacity: 0}, 0.2); //scale: '1.24%'

              // Brasil Animations
              hoverBra.fromTo($brasilText, 0.65, { color: '#000' }, { color: '#fff' });

              showBra.fromTo(
                $brasilHover,
                0.65,
                {
                  className: '-=active',
                  opacity: 0
                },
                {
                  className: '+=active',
                  opacity: 1
                }
              );

              // Himalaya Animations
              hoverHim.fromTo($himalayaText, 0.65, { color: '#000' }, { color: '#fff' });

              showHim.fromTo(
                $himalayaHover,
                0.65,
                {
                  className: '-=active',
                  opacity: 0
                },
                {
                  className: '+=active',
                  opacity: 1
                }
              );
            }

            {
              $envBrasil
                .on('mouseenter', function (e) {
                  e.preventDefault();
                  hoverBra.play();
                })
                .on('mouseleave', function (e) {
                  e.preventDefault();
                  hoverBra.reverse();
                })
                .on('click', function (e) {
                  e.preventDefault();

                  $parent.trigger('stop_autoplay');
                  showBra.play();
                });

              $envHimalaya
                .on('mouseenter', function (e) {
                  e.preventDefault();
                  hoverHim.play();
                })
                .on('mouseleave', function (e) {
                  e.preventDefault();
                  hoverHim.reverse();
                })
                .on('click', function (e) {
                  e.preventDefault();

                  $parent.trigger('stop_autoplay');
                  showHim.play();
                });

              $closeBtn.on('click', function (e) {
                var $this = $(this),
                  $activeEnvironments = $this
                    .closest('.re-nutriv-alchemy_environments')
                    .filter('.active');

                e.preventDefault();

                if ($activeEnvironments.hasClass('brasil-hover')) {
                  showBra.reverse();
                }
                if ($activeEnvironments.hasClass('himalayans-hover')) {
                  showHim.reverse();
                } else {
                  return false;
                }

                $parent.trigger('start_autoplay');
              });
            }
          })();
          // /////////////////////////////
          // END: Section 4
          // /////////////////////////////

          // /////////////////////////////
          // BEGIN: Section 5
          // /////////////////////////////
          (function () {
            var $self = $('#re-nutriv-alchemy_section-5'),
              $parallax = $self.find('.parallax-container .desktop'),
              // DOM
              $text = $self.find('.re-nutriv-alchemy_text'),
              // Animation
              parallaxAnimation,
              introAnimation = new TimelineMax({ paused: true }),
              introStarted = false;

            {
              parallaxAnimation = TweenMax.to($parallax, 1, {
                y: '-=26%',
                paused: true
              });
              introAnimation.staggerFrom($text.children(), 1, { opacity: 0 }, 0.1);
            }

            {
              /* Parallax animation handled here as it needs to function regardless of if the section is 'active' via Sector.js */
              $window.on('scroll touchmove touchend', function () {
                var progress =
                  ($window.scrollTop() - $self.offset().top + $(window).height()) /
                  ($self.offset().top + $self.height());

                progress = progress < 0 ? 0 : progress > 1 ? 1 : progress;

                parallaxAnimation.progress(progress);
              });

              $self.closest('.slide, .node').on('slideHasGainedActive', function () {
                if (!introStarted) {
                  introStarted = true;
                  introAnimation.play();
                }
              });
            }
          })();
          // /////////////////////////////
          // END: Section 5
          // /////////////////////////////

          // /////////////////////////////
          // BEGIN: Section 6
          // /////////////////////////////
          (function () {
            var $self = $('#re-nutriv-alchemy_section-6'),
              $parallax = $self.find('.parallax-container .desktop'),
              $dewDrop = $self.find('.dew-drop'),
              $dewDropText = $self.find('.re-nutriv-alchemy_text'),
              // Animation
              parallaxAnimation,
              dewDropAnimation = new TimelineMax({ paused: true }),
              dewDropAnimationStarted = false;

            {
              parallaxAnimation = TweenMax.to($parallax, 1, {
                y: '-=50%',
                paused: true
              });

              if (isMobile) {
                dewDropAnimation
                  .from($dewDrop, 1.5, {
                    y: '-100%',
                    opacity: 0
                  })
                  .staggerFrom($dewDropText.children(), 1, { opacity: 0 }, 0.21);
              } else {
                dewDropAnimation
                  .from($dewDrop, 1.5, {
                    y: '-100%',
                    opacity: 0,
                    delay: 0.5
                  })
                  .staggerFrom($dewDropText.children(), 1, { opacity: 0 }, 0.1, '-=0.75');
              }
            }

            {
              /* Parallax animation handled here as it needs to function regardless of if the section is 'active' via Sector.js */
              $window
                .on('scroll touchmove touchend', function () {
                  // ST - Bug - parallax offset top throwing type error
                  var parallax_top =
                      typeof $parallax.offset() === 'undefined' ? 0 : $parallax.offset().top,
                    progress =
                      ($window.scrollTop() - parallax_top + $(window).height()) /
                      (parallax_top + $parallax.height());

                  progress = progress < 0 ? 0 : progress > 1 ? 1 : progress;

                  parallaxAnimation.progress(progress);

                  if (
                    !dewDropAnimationStarted &&
                    $self.offset().top + $self.height() * 0.2 <=
                      $(window).scrollTop() + $(window).height()
                  ) {
                    dewDropAnimationStarted = true;
                    dewDropAnimation.play();
                  }
                })
                .on('desktopGainedMobile', function () {
                  dewDropAnimation.kill();
                  $dewDrop.attr('style', '');
                  $dewDropText.children().attr('style', '');
                });
            }

            MAIN.add(
              generateSection($self, {
                update: function () {
                  if (
                    !dewDropAnimationStarted &&
                    $self.offset().top + $self.height() * 0.2 <=
                      $(window).scrollTop() + $(window).height()
                  ) {
                    dewDropAnimationStarted = true;
                    dewDropAnimation.play();
                  }
                }
              })
            );
          })();
          // /////////////////////////////
          // END: Section 6
          // /////////////////////////////

          // /////////////////////////////
          // BEGIN: Section 7
          // /////////////////////////////
          (function () {
            var $self = $('#re-nutriv-alchemy_section-7'),
              // DOM
              $title = $self.find('.re-nutriv-alchemy_text.first > *'),
              $text = $self.find('.re-nutriv-alchemy_text.second > *'),
              $products = $self.find('.products-container'),
              $productDetails = $self.find('.product-details li'),
              $marble = $self.find('.marble-slab'),
              $flower = $self.find('.background-flower'),
              // Animation
              introStarted = false,
              introTimeline = new TimelineMax({ paused: true });

            {
              introTimeline
                .from($marble, 1, { opacity: 0 })
                .from($flower, 0.45, { opacity: 0 }, '-=0.5')
                .add(
                  [
                    TweenMax.staggerFrom(
                      $title,
                      1,
                      {
                        opacity: 0,
                        y: '+=60%'
                      },
                      0.2
                    ),
                    TweenMax.from($products, 0.85, {
                      opacity: 0,
                      y: '+=5%'
                    }),
                    TweenMax.staggerFrom($productDetails, 1, { opacity: 0 }, 0.1),
                    TweenMax.staggerFrom(
                      $text,
                      1,
                      {
                        opacity: 0,
                        y: '+=60%'
                      },
                      0.2
                    )
                  ],
                  '-=0.2',
                  'normal',
                  0.1
                )
                .staggerFrom(
                  $text.children(),
                  1,
                  {
                    opacity: 0,
                    y: '+=60%'
                  },
                  0.2
                );
            }

            MAIN.add(
              generateSection($self, {
                update: function () {
                  if (
                    !introStarted &&
                    $self.offset().top + $self.height() * 0.1 <
                      $(window).scrollTop() + $(window).height()
                  ) {
                    introStarted = true;
                    introTimeline.play();
                  }
                }
              })
            );
          })();
          // /////////////////////////////
          // END: Section 7
          // /////////////////////////////
        });

        // /////////////////////////////////
        // BEGIN: COREMETRICS
        // /////////////////////////////////
        (function () {
          if (window.location.href.indexOf('dynamic.li') > -1) {
            return;
          }

          var forceFlag = $siteContainer.hasClass('it_IT') ? 1 : 0;
          var cmSettings = {
            options: {
              debug: debug,
              cat_id: 'CAT', // CAT ID
              element_cat: 'Estee Supreme Boutique', // Boutique Name
              force: forceFlag // Force CoreMetrics on some servers
            },
            section: [
              {
                tag: 'Landing',
                element_tag: {}
              }
            ]
          };

          $siteContainer.elmetrics(cmSettings);
        })();
        // ///////////////////////////////////
        // END: COREMETRICS
        // ///////////////////////////////////

        // /////////////////////////////////
        // BEGIN: Preloader
        // /////////////////////////////////
        (function () {
          var $loader = $siteContainer.find('#loader'),
            preloadTargets = [],
            spinnerOptions = {
              lines: 17, // The number of lines to draw
              length: 0, // The length of each line
              width: 5, // The line thickness
              radius: 26, // The radius of the inner circle
              scale: 1, // Scales overall size of the spinner
              corners: 1, // Corner roundness (0..1)
              color: '#000', // #rgb or #rrggbb or array of colors
              opacity: 0.5, // Opacity of the lines
              rotate: 0, // The rotation offset
              direction: 1, // 1: clockwise, -1: counterclockwise
              speed: 1, // Rounds per second
              trail: 30, // Afterglow percentage
              zIndex: 2e9, // The z-index (defaults to 2000000000)
              className: 'spinner', // The CSS class to assign to the spinner
              top: '50%', // Top position relative to parent
              left: '50%', // Left position relative to parent
              shadow: false, // Whether to render a shadow
              hwaccel: true, // Whether to use hardware acceleration
              position: 'absolute' // Element positioning
            },
            spinner = new Spinner(spinnerOptions).spin($loader[0]),
            $deeplinkSection = deeplinkMethods.getDeeplink(),
            // Object/SVG loading
            $objects = $siteContainer.find('object'),
            objectsToLoad = $objects.length,
            objectsLoaded = 0;

          /**
           * @function triggerPreload
           * @description Helper function for preload
           * @returns {undefined} This function doesn't return anything
           */
          function triggerPreload() {
            if (debug) {
              console.log('triggerPreload: Preload Triggered');
            }

            $(preloadTargets).FreeLoader({
              debug: debug,
              callback: function () {
                // Ensure the rest of the images have been swapped in
                $siteContainer.find('img, .preload').each(function () {
                  var $this = $(this),
                    dataSrc = $this.data('src');

                  if (typeof dataSrc !== 'undefined') {
                    $this.attr('src', dataSrc);
                  }
                });

                // Delay used to ensure enough images are loaded before displaying site
                TweenMax.to($loader, 1, {
                  opacity: 0,
                  display: 'none',
                  delay: 2,
                  onComplete: function () {
                    spinner.stop();
                    $window.trigger('scroll');

                    // Deeplink handling
                    if (
                      typeof $deeplinkSection !== 'undefined' &&
                      $deeplinkSection.length !== 0 &&
                      typeof $deeplinkSection.data('section') !== 'undefined'
                    ) {
                      deeplinkMethods.deeplinking = true;
                      $deeplinkSection.data('section').deeplink();
                    }

                    // TweenMax.to($window, 1, {scrollTo: {y: $deeplinkSection.offset().top}});
                  }
                });
                postLoad();
              }
            });
          }

          // Deeplink'd section gets preload priority over all other sections
          preloadTargets.push(
            $deeplinkSection.find('img, .preload').not(isMobile ? '.desktop' : '.mobile')
          );
          $siteContainer
            .find('.' + sectionClass)
            .not($deeplinkSection)
            .each(function () {
              preloadTargets.push(
                $(this)
                  .find('img, .preload')
                  .not(isMobile ? '.desktop' : '.mobile')
              );
            });

          // Load objects if there are any, otherwise skip to image preloading
          if (objectsToLoad !== 0) {
            if (debug) {
              console.log('Found: ' + objectsToLoad, $objects);
            }

            // Attach load event to each object
            $objects.each(function () {
              var $this = $(this);

              // Object must have data set and not blank, if so, decrement and don't listen for load
              if (
                typeof $this.attr('data') === 'undefined' ||
                $this.attr('data').trim().length === 0 ||
                $this.hasClass('loaded')
              ) {
                if (debug) {
                  console.log('No data to load from: ', $this);
                }

                objectsToLoad--;

                if (objectsToLoad === 0) {
                  triggerPreload();
                }

                return;
              }

              if (debug) {
                console.log('Loading data for: ', $this);
              }

              this.addEventListener('load', function () {
                objectsLoaded++;

                if (debug) {
                  console.log('Loaded: ', $this);
                }

                // Trigger normal image preloading after objects have loaded
                if (objectsLoaded >= objectsToLoad) {
                  triggerPreload();
                }
              });
            });
          } else {
            triggerPreload();
          }
        })();

        // /////////////////////////////////
        // END: Preloader
        // /////////////////////////////////
      })(jQuery);
      // /////////////////////////////////
      // END: Boutique Implementation
      // /////////////////////////////////
    }
  };
})(jQuery);
